import GLightbox from 'glightbox';

// Document load/ready promise, calls 'ready' method when completed
HTMLDocument.prototype.ready = function () {
  return new Promise(function(resolve, reject) {
    if (document.readyState === 'complete') {
      resolve(document);
    } else {
      document.addEventListener('DOMContentLoaded', function() {
        resolve(document);
      });
    }
  });
};

document.ready().then(function() {

  let lightboxSlideHtml = `
  <div class="gslide">
    <div class="gslide-inner-content">
      <div class="ginner-container">
        <div class="flex-center relative fill">
          <div class="gslide-media flex-center relative">
            <svg class="prev svg svg--left svg--arrow arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 30" ><path d="M0 15C0 7.5 7.5 0 15 0h26c7.5 0 15 7.5 15 15s-7.5 15-15 15H15C7.5 30 0 22.5 0 15z" fill="#fff"/><path class="arrow-fill" d="M10.008 14.998L16.165 9l1.254.667-4.864 4.723H22v1.21h-9.451l4.87 4.729-1.254.667z" fill="#b2b2b2"/></svg>
            <svg class="next svg svg--right svg--arrow arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 30"><path d="M56 15c0 7.5-7.5 15-15 15H15C7.5 30 0 22.5 0 15S7.5 0 15 0h26c7.5 0 15 7.5 15 15z" fill="#fff"/><path d="M45.992 15.002L39.835 21l-1.254-.667 4.864-4.723H34V14.4h9.451l-4.87-4.729 1.254-.667z" class="arrow-fill" fill="#b2b2b2"/></svg>
            <svg class="close svg svg--closeButton" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 30" aria-hidden="true"><path class="svg-circle" d="M0 15C0 7.5 7.5 0 15 0h2c7.5 0 15 7.5 15 15s-7.5 15-15 15h-2C7.5 30 0 22.5 0 15z" fill="#fff"/><path class="svg-x" d="M21.5 9.5l-11 11M10.5 9.5l11 11" stroke-miterlimit="50" fill="none" stroke="#bebebe" stroke-width="2"/></svg>
          </div>
        </div>

        <div class="gslide-description">
          <div class="gdesc-inner">
            <h4 class="gslide-title"></h4>
            <div class="gslide-desc"></div>
          </div>
        </div>
      </div>
    </div>
  </div>`;


  const lightbox = GLightbox({
    touchNavigation: true,
    loop: true,
    slideHtml: lightboxSlideHtml,
    closeButton: false,
    onOpen: () => {
        var closeButtons = document.querySelectorAll('.gcontainer .close');
        var prevButtons = document.querySelectorAll('.gcontainer .prev');
        var nextButtons = document.querySelectorAll('.gcontainer .next');

        for(let button of closeButtons) {
          button.addEventListener('click', function() {
            lightbox.close();
          });
        }


        for(let button of prevButtons) {
          button.addEventListener('click', function() {
            lightbox.prevSlide();
          });
        }


        for(let button of nextButtons) {
          button.addEventListener('click', function() {
            lightbox.nextSlide();
          });
        }
    }
  });
});


